<template>
  <el-dialog @close="dialogClose"
             :visible.sync="visible"
             :title="(dialogStatus==='create'?'新增':'编辑')+'流水段'">
    <el-form :model="editFlowForm"
             ref="editFlowForm"
             :rules="formRules"
             label-width="100px">
      <el-row>
        <el-col :span="20">
          <el-form-item prop="section_name"
                        label="流水段名称">
            <el-input v-model="editFlowForm.section_name"
                      placeholder="请输入流水段名称">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="pipeline_start"
                        label="开始流水">
            <el-input v-model="editFlowForm.pipeline_start"
                      placeholder="请输入开始流水">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8"
                :offset="4">
          <el-form-item prop="pipeline_end"
                        label="截止流水">
            <el-input v-model="editFlowForm.pipeline_end"
                      placeholder="请输入截止流水">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="dialogClose" style="margin-right:12px">取 消</el-button>
      <el-button type="primary"
                 @click="editFlowSection">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { EncodeRuleApi } from '@/services/EncodeRule'
export default {
  data () {
    return {
      visible: false,
      editFlowForm: {
        section_name: '',
        pipeline_start: '',
        pipeline_end: '',
        rule_code_resolve_id: ''
      },
      tempForm: {
        section_name: '',
        pipeline_start: '',
        pipeline_end: '',
        rule_code_resolve_id: ''
      },
      formRules: {
        section_name: [
          { required: true, message: '请输入流水名称', trigger: 'blur' }
        ],
        pipeline_start: [
          { required: true, message: '请输入开始流水', trigger: 'blur' }
        ],
        pipeline_end: [
          { required: true, message: '请输入截止流水', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogForm: {
      type: Object
    },
    dialogStatus: {
      type: String
    },
    callback: {
      type: Function
    }
  },
  watch: {
    dialogVisible (newval) {
      this.visible = newval
    },
    dialogForm: {
      handler (newval) {
        let tempForm = JSON.parse(JSON.stringify(this.tempForm))
        this.editFlowForm = Object.assign(tempForm, JSON.parse(JSON.stringify(newval)))
      },
      deep: true
    }
  },
  methods: {
    dialogClose () {
      this.$emit('update:dialogVisible', false)
    },
    editFlowSection () {
      this.$refs.editFlowForm.validate((valid) => {
        if (valid) {
          if (this.dialogStatus === 'create') {
            this.createFlowSection()
          }
        }
      })
    },
    createFlowSection () {
      EncodeRuleApi.createFlowSection({
        data: this.editFlowForm
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('新增流水段成功')
          this.$emit('callback', res)
          this.dialogClose()
        }
      })
    },
    updateFlowSection () {

    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
.dialog-footer{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/SettingManage/components/EditFlowSectionDIalog.vue